export enum EBusinessType {
  POD = 'pod',
  DROPSHIPPING = 'dropshipping',
  BRANDED = 'branded',
}
export type TAppConfig = {
  currentBusinessType: EBusinessType | null;
  selectedShopifyShopId: string | null;
};
